// What a refusal placing an order may be asked about (ai_app_backend #2157; "Ask for a review", lib/appeals.ts). Kept
// apart, with nothing but itself, because the suggestion's notice (lib/prompt-adjusted.ts) is on every page through the
// root layout's toast and must not bring the v2 client with it.

/**
 * What a prompt refused as its order was placed may be asked about (ai_app_backend #2157): v2's `422 words_refused`
 * from an order-placing route carries `appeal_ref` (sent as the appeal's `order_id`, with no picture) and
 * `appealable`. Only when `appealable` is true and `appeal_ref` is set; otherwise nothing, the refusal as before.
 * Carried on the adapter's v1-shaped answer as `appeal`, which the Create page reads (messages.tsx `bannedWord`).
 */
export function placingAppeal(error: unknown): {
  appeal?: { order_id: string; picture: null; appealable: true }
} {
  const { appealable, appeal_ref } = (typeof error === 'object' && error !== null ? error : {}) as {
    appealable?: unknown
    appeal_ref?: unknown
  }
  return appealable === true && typeof appeal_ref === 'string' && appeal_ref
    ? { appeal: { order_id: appeal_ref, picture: null, appealable: true } }
    : {}
}
